import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import ComplaintPreviewHeaderOverview from './ComplaintPreviewHeaderOverview';
import ComplaintPreviewCustomerOverview from './ComplaintPreviewCustomerOverview';
import ComplaintPositionOverview from '../ComplaintPostionOverview/ComplaintPositionOverview';
import Moment from 'moment';
import textTranslates from './translate.json';
import OverviewTableRow from '../base/Table/OverviewTableRow';
import OverviewTable from '../base/Table/OverviewTable';

const ComplaintPreview = (props) => {
    
    return(
        <div 
            className="col-xs-12"
            id="complaintPreview">
            <Title
                large
                id="complaintPreviewTitle"
                title={textTranslates.complaintPreviewTitle} />
            
            <ComplaintPreviewHeaderOverview
                complaint={props.complaint} />
            <ComplaintPreviewCustomerOverview
                customer={props.customer} />
            
            {props.complaintPositions.map(position => {
                return(
                <ComplaintPositionOverview
                key={position.id}
                canEditWaybill={props.showEditButton}
                complaintPosition={position}
                componentsToRender={props.componentsToRender}
                complaintType={props.complaint.complaintType}
                onEditWaybillDataButtonClick={props.onEditWaybillDataButtonClick}/>);
            })}
            <OverviewTable>
            <tbody style={{fontWeight: "bold", fontSize: "18px"}}>
            {props.complaint.notes != undefined &&  props.complaint.erpStatus?
                <OverviewTableRow 
                id="notes"
                value={props.complaint.notes}
                label={textTranslates.notes}
                />: null} 
           </tbody>
           </OverviewTable>
        </div>
    );
};

ComplaintPreview.propTypes = {
    customer: PropTypes.shape({
        type: PropTypes.shape({
            value: PropTypes.string
        }),
        companyName: PropTypes.string,
        companyTax: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        street: PropTypes.string,
        flatNumber: PropTypes.string,
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string
    }),
    complaint: PropTypes.shape({
        complaintType: PropTypes.shape({
            displayName: PropTypes.string
        }),
        number: PropTypes.string,
    }),
    complaintPositions: PropTypes.array,
    onEditWaybillDataButtonClick: PropTypes.func,
    showEditButton: PropTypes.bool,
    componentsToRender: PropTypes.array
};

export default ComplaintPreview;


// WEBPACK FOOTER //
// ./src/components/ComplaintPreview/ComplaintPreview.js